<template lang="pug">
form.form-section.prose.dark_prose-invert.max-w-none.bg-gray-100.dark_bg-gray-800.p-6.rounded-lg.mb-8(@submit.prevent="$emit('save')")
  h2.text-xl.font-bold.mb-4 {{ title }}
  
  // Unique form fields for the section will be injected here
  slot

  .text-right.mt-6
    button.btn.bg-gray-500.text-white.py-2.px-4.rounded.mr-2(
      v-if="canReset"
      @click="$emit('reset')"
      type="button"
    ) Reset
    button.save-btn.py-2.px-4.bg-primary-600.text-white.rounded(
      type="submit"
      :disabled="isSaving || !canSave"
      :class="isSaving || !canSave ? 'opacity-50 cursor-not-allowed bg-gray-400' : 'bg-primary-600'"
    )
      span(v-if="isSaving") Saving...
      span(v-else) Save
</template>

<script lang="ts">
export default {
  name: 'FormSection'
};
</script>

<script setup lang="ts">
defineProps<{
  title: string;
  sectionName: string;
  isSaving: boolean;
  canSave: boolean;
  canReset: boolean;
}>();

defineEmits(['save', 'reset']);
</script>
